import { ServiceData } from '..';
// eslint-disable-next-line import/prefer-default-export
export class AbsMemberCompanyInquiry extends ServiceData {
    reqBody;
    constructor(form) {
        super();
        this.reqBody = {
            id: form.id,
            title: form.title,
            body: form.body,
            requestType: form.processingType,
        };
    }
}
